import createIcon from '../../createIcon';

/**
 * @component @name FivekPlus
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk05LjUgMTAuNUg2LjVWMTEuNUg4LjVDOS4wNSAxMS41IDkuNSAxMS45NSA5LjUgMTIuNVYxNEM5LjUgMTQuNTUgOS4wNSAxNSA4LjUgMTVINVYxMy41SDhWMTIuNUg1VjlIOS41VjEwLjVaTTE2IDE1SDE0LjI1TDEyLjUgMTIuNzVWMTVIMTFWOUgxMi41VjExLjI1TDE0LjI1IDlIMTZMMTMuNzUgMTJMMTYgMTVaTTIwIDEyLjVIMTguNVYxNEgxNy41VjEyLjVIMTZWMTEuNUgxNy41VjEwSDE4LjVWMTEuNUgyMFYxMi41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FivekPlus = createIcon('FivekPlus', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9.5 10.5H6.5V11.5H8.5C9.05 11.5 9.5 11.95 9.5 12.5V14C9.5 14.55 9.05 15 8.5 15H5V13.5H8V12.5H5V9H9.5V10.5ZM16 15H14.25L12.5 12.75V15H11V9H12.5V11.25L14.25 9H16L13.75 12L16 15ZM20 12.5H18.5V14H17.5V12.5H16V11.5H17.5V10H18.5V11.5H20V12.5Z',
      key: '136ll4',
    },
  ],
]);

export default FivekPlus;
